import React, { createContext, useState, useContext, useEffect } from 'react';
import { useFetch } from '../services/Requests/useFetch';
import { useObserver } from './http/routing/ObserverContext';
import { useEmail } from './http/routing/EmailContext';

// Create a context for backend time offset
const ActiveUsersContext = createContext();

// Custom hook to use the ActiveUsersContext
// In the hook:
export const useActiveUsers = () => {
  const context = useContext(ActiveUsersContext);
  if (context === null || context === undefined) {
    throw new Error('useActiveUsers must be used within a ActiveUsersProvider');
  }
  return context; // contains { activeUsers }
};

// Provider component to manage backend time offset
export const ActiveUsersProvider = ({ children }) => {
  const fetchActiveUsers = useFetch('/api/missions/sync_users', { method: 'GET' });
  const [activeUsers, setActiveUsers] = useState(null);
  const {isObserver} = useObserver()
  const {userEmail} = useEmail()
  const syncActiveUser = () => {
    // console.log(`Syncing User: ${userEmail}`)
    fetchActiveUsers.get([
            { param: 'user', value: userEmail }
          ]);
  };
  
    useEffect(() => {
      // Initial fetch
      if (!isObserver){
        syncActiveUser();

        // Set up interval to fetch backend time regularly
        const interval = setInterval(syncActiveUser, 60000); // Update every 5 minutes

        return () => {
          clearInterval(interval);
          fetchActiveUsers.abortRequest && fetchActiveUsers.abortRequest();
        };
      }
    }, []);


  useEffect(() => {
    const { state: { status, data } } = fetchActiveUsers;
    // console.log(fetchActiveUsers.state)

    if (status === 'fetched' && data) {
      try {
        // console.log(data)
        setActiveUsers(data);
      } catch (error) {
        console.error('Failed to sync Active Users:', error);
        setActiveUsers(null);
      }
    }
  }, [fetchActiveUsers.state]);

  return (
    <ActiveUsersContext.Provider value={{ activeUsers }}>
      {children}
    </ActiveUsersContext.Provider>
  );
};
